
export const lst_frecuencia = [{ id: 1, nombre: "Semanal" }, { id: 2, nombre: "Quincenal" }, { id: 3, nombre: "Mensual" }, { id: 4, nombre: "Personalizado" }]


export const SEMANAL = 1;
export const QUINCENAL = 2;
export const MENSUAL = 3;
export const PERSONALIZADO = 4;


